export const issueGameToken = async (context) => {
  const {
    gameAuthService, guid, ticket, targetGid, logger,
  } = context

  const { success, data, error } = await gameAuthService.insignGameAuth.issueGameToken(
    guid,
    ticket,
    { gid: targetGid },
  )

  if (!success) {
    throw error
  }

  logger.addBreadcrumb({
    type: 'info',
    category: 'sso-for-web-game',
    message: 'Game token issued successfully',
    data: {
      game_token: data.gameToken,
    },
    level: 'info',
  })
}
